import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsForm from '@/components/vision/VsForm.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCreationForm',
  emits: ['save'],
  setup(__props, { expose, emit }) {


const store = useStore()
const projectForm = ref(null)
const projectName = ref('')

// Computed properties
const saving = computed(() => store.state.projects.saving)

// Methods
const setProjectName = (newName: string) => {
  projectName.value = newName
}

const save = async () => {
  if (!projectForm.value?.isValid()) {
    return
  }

  emit('save', projectName.value)
}

expose({
  save,
})

return { __sfc: true,emit, store, projectForm, projectName, saving, setProjectName, save, VsWrapper, VsHeading, VsButton, VsForm, VsTextInput }
}

})